const fetchProductCardHTML = (handle) => {
  return fetch(`/products/${handle}?view=card`)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCardWrapper = document.createElement('li');
      productCardWrapper.className = 'grid__item';
      const productCard =
        htmlDocument.documentElement.querySelector('.card--product');
      productCardWrapper.appendChild(productCard);
      return productCardWrapper.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

async function createWishlistCards(result) {
  let productHandles = [];
  result.forEach((item) => {
    productHandles.push(item.handle);
  });
  const requests = productHandles.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  document.querySelector('#wishlist-container').innerHTML =
    wishlistProductCards;
}

if (window.CUSTOMER && window.CUSTOMER.id) {
  const url = `https://api.myshopapps.com/wishlist/V2/${
    'fetchWishlistData/' + window.CUSTOMER.id
  }`;
  const options = {
    method: 'GET',
    headers: {
      xtoken: 'IWISH_API_ca961a90cb8511f0a0270e72f2521631',
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    console.log('success');
    localStorage.setItem('iWishlistmain', JSON.stringify(data.result));
    if (document.querySelector('#wishlist-container'))
      createWishlistCards(data.result);
    if (data.result.length > 0) {
      console.log('yes');
      document
        .querySelector('.header__nav-icon-wish-span')
        .removeAttribute('hidden');
      document.querySelector('.header__nav-icon-wish-span').innerHTML =
        data.result.length;
    } else {
      console.log('no');
      document
        .querySelector('.header__nav-icon-wish-span')
        .setAttribute('hidden', '');
    }
  } catch (error) {
    console.error(error);
  }
} else {
  if (
    JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')) &&
    JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length > 0
  ) {
    if (document.querySelector('#wishlist-container'))
      createWishlistCards(
        JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin'))
      );
    document
      .querySelector('.header__nav-icon-wish-span')
      .removeAttribute('hidden');
    document.querySelector('.header__nav-icon-wish-span').innerHTML =
      JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length;
  } else {
    document
      .querySelector('.header__nav-icon-wish-span')
      .setAttribute('hidden', '');
  }
}

class WishHeart extends HTMLElement {
  constructor() {
    super();
    this.spanNumber = document.querySelector('.header__nav-icon-wish-span');
    this.notificationContainer = this.closest(
      '[data-wishlist-notification-container]'
    );
    this.notification =
      this.notificationContainer?.querySelector('.wishlist-notification');
    this.isProductPage = this.classList.contains('wish-heart_product-info');
    this.init();
  }

  showNotification() {
    if (this.isProductPage || !this.notification) return;

    if (!this.notificationContainer) return;

    const heartRect = this.getBoundingClientRect();
    const containerRect = this.notificationContainer.getBoundingClientRect();

    this.notification.style.display = 'block';
    this.notification.style.visibility = 'hidden';
    void this.notification.offsetWidth;
    const notificationHeight = this.notification.offsetHeight;
    const notificationWidth = this.notification.offsetWidth;
    this.notification.style.visibility = '';

    const notificationBottom = containerRect.bottom - heartRect.top + 6 + 12;
    // Center notification on the heart, clamped within container bounds, shifted 30px right
    const heartCenter = heartRect.left - containerRect.left + heartRect.width / 2;
    const rawLeft = heartCenter - notificationWidth / 2 - 30;
    const notificationLeft = Math.max(0, Math.min(rawLeft, containerRect.width - notificationWidth));

    // #region agent log
    fetch('http://127.0.0.1:7416/ingest/2ec8a83a-0cfa-48bf-b19e-5cbda8bf37f4',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5fa843'},body:JSON.stringify({sessionId:'5fa843',location:'iwishlist.js:showNotification',message:'positioning rects v4',data:{heartCenter,rawLeft,notificationLeft,notificationWidth,containerWidth:containerRect.width,notificationBottom},timestamp:Date.now()})}).catch(()=>{});
    // #endregion

    this.notification.style.top = 'auto';
    this.notification.style.bottom = `${notificationBottom}px`;
    this.notification.style.left = `${notificationLeft}px`;
    this.notification.style.right = 'auto';
    this.notification.style.transform = 'none';

    void this.notification.offsetWidth;

    this.notification.classList.add('show');

    setTimeout(() => {
      this.notification.classList.remove('show');
      setTimeout(() => {
        this.notification.style.display = 'none';
      }, 200);
    }, 2000);
  }

  async handleFetchAdd(product_id, variant_id) {
    const url = `https://api.myshopapps.com/wishlist/V2/addToWishlist`;
    const options = {
      method: 'POST',
      headers: {
        xtoken: 'IWISH_API_ca961a90cb8511f0a0270e72f2521631',
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: new URLSearchParams({
        customer_id: window.CUSTOMER.id,
        product_id,
        variant_id,
      }),
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
    } catch (error) {
      console.error(error);
    }
  }

  async handleFetchRemove(variant_id) {
    const url = `https://api.myshopapps.com/wishlist/V2/removeWishlist?customer_id=${window.CUSTOMER.id}&variant_id=${variant_id}`;
    const options = {
      method: 'DELETE',
      headers: {
        xtoken: 'IWISH_API_ca961a90cb8511f0a0270e72f2521631',
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
    } catch (error) {
      console.error(error);
    }
  }

  handleAddLocalStorage() {
    const localStorageData = JSON.parse(
      localStorage.getItem('iWishlistmainNotLoggedin')
    );
    const newItem = {
      id: this.dataset.productId,
      handle: this.dataset.handle,
    };
    let newLocalStorageData = [];
    localStorageData
      ? (newLocalStorageData = localStorageData.concat(newItem))
      : (newLocalStorageData = [newItem]);
    localStorage.setItem(
      'iWishlistmainNotLoggedin',
      JSON.stringify(newLocalStorageData)
    );
  }

  handleRemoveLocalStorage() {
    const localStorageData = JSON.parse(
      localStorage.getItem('iWishlistmainNotLoggedin')
    );
    const updatedArray = localStorageData.filter(
      (obj) => obj.id != this.dataset.productId
    );
    localStorage.setItem(
      'iWishlistmainNotLoggedin',
      JSON.stringify(updatedArray)
    );
  }

  addToWishlistEvent() {
    this.removeEventListener('click', this.handleRemoveFromWishlist);
    this.addEventListener('click', this.handleAddToWishlist);
  }

  removeToWishlistEvent() {
    this.removeEventListener('click', this.handleAddToWishlist);
    this.addEventListener('click', this.handleRemoveFromWishlist);
  }

  handleAddToWishlist = () => {
    const isLoggedIn = window.CUSTOMER && window.CUSTOMER.id;

    if (isLoggedIn) {
      this.handleFetchAdd(
        Number(this.dataset.productId),
        Number(this.dataset.variantId)
      );
    } else {
      this.handleAddLocalStorage();
    }

    if (this.isProductPage) {
      document
        .querySelectorAll(
          `wish-heart[data-handle="${this.getAttribute('data-handle')}"]`
        )
        .forEach((heart) => {
          const svg = heart.querySelector('svg');
          const heartPath = heart.querySelector('svg.heart path');
          if (svg) svg.style.fill = '#F00';
          if (heartPath) heartPath.style.stroke = '#F00';
        });
    } else {
      document
        .querySelectorAll(
          `wish-heart[data-handle="${this.getAttribute('data-handle')}"]`
        )
        .forEach((heart) => {
          const svg = heart.querySelector('svg');
          const heartPath = heart.querySelector('svg.heart path');
          if (svg) svg.style.fill = '#F00';
          if (heartPath) heartPath.style.stroke = '#F00';
        });
    }

    if (this.spanNumber) {
      this.spanNumber.innerText = Number(this.spanNumber.innerText) + 1;
      if (this.spanNumber.innerText != '0') {
        this.spanNumber.removeAttribute('hidden');
      }
    }
    // Only show notification on product cards, not product page
    if (!this.isProductPage) {
      this.showNotification();
    }
    this.removeToWishlistEvent();
  };

  handleRemoveFromWishlist = () => {
    window.CUSTOMER && window.CUSTOMER.id
      ? this.handleFetchRemove(Number(this.dataset.variantId))
      : this.handleRemoveLocalStorage();
    if (this.isProductPage) {
      document
        .querySelectorAll(
          `wish-heart[data-handle="${this.getAttribute('data-handle')}"]`
        )
        .forEach((heart) => {
          const svg = heart.querySelector('svg');
          const heartPath = heart.querySelector('svg.heart path');
          if (svg) svg.style.fill = 'none';
          if (heartPath) heartPath.style.stroke = '#150B53';
        });
    } else {
      document
        .querySelectorAll(
          `wish-heart[data-handle="${this.getAttribute('data-handle')}"]`
        )
        .forEach((heart) => {
          const svg = heart.querySelector('svg');
          const heartPath = heart.querySelector('svg.heart path');
          if (svg) svg.style.fill = 'none';
          if (heartPath) heartPath.style.stroke = '#2A2B2A';
        });
    }
    if (this.spanNumber) {
      this.spanNumber.innerText = Number(this.spanNumber.innerText) - 1;
      if (this.spanNumber.innerText == '0') {
        this.spanNumber.setAttribute('hidden', '');
      }
    }
    if (document.querySelector('#wishlist-container')) {
      this.closest('.grid__item').remove();
      // Update empty state after removing item
      setTimeout(() => updateWishlistState(), 100);
    }
    this.addToWishlistEvent();
  };

  init() {
    const iWishlistmain =
      window.CUSTOMER && window.CUSTOMER.id
        ? localStorage.getItem('iWishlistmain')
        : localStorage.getItem('iWishlistmainNotLoggedin');

    if (
      iWishlistmain &&
      JSON.parse(iWishlistmain).some((obj) => obj.id === this.dataset.productId)
    ) {
      this.removeToWishlistEvent();
      const heartSvg = this.querySelector('svg.heart');
      const heartPath = this.querySelector('svg.heart path');
      const productWish = this.querySelector('svg.product-wish');

      if (heartSvg) heartSvg.style.fill = '#F00';
      if (heartPath) heartPath.style.stroke = '#F00';
      if (productWish) productWish.style.fill = '#fff';
    } else {
      this.addToWishlistEvent();
      const svg = this.querySelector('svg');
      const heartPath = this.querySelector('svg.heart path');

      if (svg) svg.style.fill = 'none';
      if (heartPath) heartPath.style.stroke = '#2A2B2A';
    }
  }
}

customElements.define('wish-heart', WishHeart);

// Wishlist empty state logic
function updateWishlistState() {
  // Only run on wishlist page
  const wishlistContainer = document.getElementById('wishlist-container');
  if (!wishlistContainer) return;

  const isLoggedIn = window.CUSTOMER && window.CUSTOMER.id;
  const iWishlistmain = isLoggedIn
    ? localStorage.getItem('iWishlistmain')
    : localStorage.getItem('iWishlistmainNotLoggedin');

  const wishlistData = iWishlistmain ? JSON.parse(iWishlistmain) : [];
  const isEmpty = wishlistData.length === 0;

  const hasItemsContent = document.getElementById('wishlist-has-items-content');
  const emptyStateContent = document.getElementById('wishlist-empty-state');
  const wishlistHeading = document.getElementById('wishlist-heading');
  const emptyHeading = document.getElementById('wishlist-empty-heading');
  const featuredCollections = document.querySelectorAll('.cc-featured-collection');
  const featuredCollection = featuredCollections.length > 0 ? featuredCollections[0] : null;
  const collectionWishlist = document.querySelector('.collection-wishlist');

  if (isEmpty) {
    // Show empty state
    if (hasItemsContent) hasItemsContent.setAttribute('hidden', '');
    if (emptyStateContent) emptyStateContent.removeAttribute('hidden');
    if (wishlistContainer) wishlistContainer.setAttribute('hidden', '');
    if (wishlistHeading) wishlistHeading.setAttribute('hidden', '');
    if (emptyHeading) emptyHeading.removeAttribute('hidden');
    if (featuredCollection) featuredCollection.removeAttribute('hidden');
    if (collectionWishlist) collectionWishlist.classList.add('empty-state');
  } else {
    // Show wishlist items
    if (hasItemsContent) hasItemsContent.removeAttribute('hidden');
    if (emptyStateContent) emptyStateContent.setAttribute('hidden', '');
    if (wishlistContainer) wishlistContainer.removeAttribute('hidden');
    if (wishlistHeading) wishlistHeading.removeAttribute('hidden');
    if (emptyHeading) emptyHeading.setAttribute('hidden', '');
    if (featuredCollection) featuredCollection.setAttribute('hidden', '');
    if (collectionWishlist) collectionWishlist.classList.remove('empty-state');
  }
}

// Remove all wishlist items functionality
document.addEventListener('DOMContentLoaded', () => {
  // Check empty state on page load
  updateWishlistState();

  // Also check after wishlist items are loaded
  setTimeout(updateWishlistState, 500);

  const removeAllBtn = document.getElementById('remove-all-wishlist');

  if (removeAllBtn) {
    removeAllBtn.addEventListener('click', async () => {
      const isLoggedIn = window.CUSTOMER && window.CUSTOMER.id;

      if (isLoggedIn) {
        // For logged-in users, remove all items from API
        const iWishlistmain = localStorage.getItem('iWishlistmain');
        if (iWishlistmain) {
          const wishlistItems = JSON.parse(iWishlistmain);

          // Remove each item from the API
          const removePromises = wishlistItems.map((item) => {
            const url = `https://api.myshopapps.com/wishlist/V2/removeWishlist?customer_id=${window.CUSTOMER.id}&variant_id=${item.variant_id}`;
            return fetch(url, {
              method: 'DELETE',
              headers: {
                xtoken: 'IWISH_API_ca961a90cb8511f0a0270e72f2521631',
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
              },
            });
          });

          await Promise.all(removePromises);
        }

        // Clear localStorage
        localStorage.setItem('iWishlistmain', JSON.stringify([]));
      } else {
        // For non-logged-in users, just clear localStorage
        localStorage.setItem('iWishlistmainNotLoggedin', JSON.stringify([]));
      }

      // Clear the wishlist container
      const wishlistContainer = document.querySelector('#wishlist-container');
      if (wishlistContainer) {
        wishlistContainer.innerHTML = '';
      }

      // Update the wishlist counter
      const spanNumber = document.querySelector('.header__nav-icon-wish-span');
      if (spanNumber) {
        spanNumber.setAttribute('hidden', '');
        spanNumber.innerText = '0';
      }

      // Update empty state
      updateWishlistState();
    });
  }
});
